export default {
  home: '首页',
  login: '登录',
  components: '组件',
  count_to_page: '数字渐变',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown编辑器',
  editor_page: '富文本编辑器',
  icons_page: '自定义图标',
  img_cropper_page: '图片编辑器',
  update: '上传数据',
  join_page: 'QQ群',
  doc: '文档',
  update_table_page: '上传CSV文件',
  update_paste_page: '粘贴表格数据',
  multilevel: '多级菜单',
  directive_page: '指令',
  excel: 'Excel',
  'upload-excel': '上传excel',
  'export-excel': '导出excel',
  tools_methods_page: '工具函数',
  drag_list_page: '拖拽列表',
  i18n_page: '多语言',
  modalTitle: '模态框题目',
  content: '这是模态框内容',
  buttonText: '显示模态框',
  'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',
  error_store_page: '错误收集',
  error_logger_page: '错误日志',
  query: '带参路由',
  params: '动态路由',
  cropper_page: '图片裁剪',
  message_page: '消息中心',
  tree_table_page: '树状表格',
  org_tree_page: '组织结构树',
  drag_drawer_page: '可拖动抽屉',
  tree_select_page: '树状下拉选择器',
  // 菜单
  sys_manage: '系统管理',
  sys_organization: '组织管理',
  sys_tenant: '租户管理',
  sys_company: '企业管理',
  sys_department: '部门管理',
  sys_orgs: '组织机构树',
  sys_post: '岗位管理',
  sys_user: '人员管理',
  sys_permission: '权限管理',
  sys_role: '角色管理',
  sys_setting: '系统设置',
  sys_config: '参数设置',
  sys_menu: '菜单管理',
  sys_dict: '字典管理',
  sys_dict_data: '字典数据',
  sys_area: '行政区划'
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js